<template>
	<div class="cp cp-instashop">
		<figure class="cp-image">
			<div class="cp-badges-container">
				<div v-if="item.discount_percent_custom > 0" class="cp-badge-cnt">
					<span class="cp-badge cp-badge-discount">-{{item.discount_percent_custom}}%</span>
				</div>
			</div>
			<NuxtLink :to="item.url_without_domain">
				<BaseUiImage loading="lazy" :data="item.main_image_thumbs?.['width120-height120']" default="/images/no-image-120.jpg" :title="item.main_image_title" :alt="item.main_image_description ? item.main_image_description : ''" />
			</NuxtLink>
		</figure>

		<div class="cp-cnt">
			<div class="cp-rates-cnt">
				<FeedbackRates :rates="item.feedback_rate_widget.rates" />
			</div>
			<div v-if="item.manufacturer_url && item.manufacturer_url_without_domain && item.manufacturer_title" class="cp-brand">
				<NuxtLink :to="item.manufacturer_url_without_domain">{{item.manufacturer_title}}</NuxtLink>
			</div>
			<h2 v-if="item.title" class="cp-title"><NuxtLink :to="item.url_without_domain">{{item.title}}</NuxtLink></h2>
			<div class="cp-price">
				<template v-if="(item.discount_percent > 0 || item.price_custom < item.basic_price)">
					<div class="cp-discount-price"><BaseUtilsFormatCurrency :price="item.price_custom" /></div>
				</template>
				<template v-else>
					<div class="cp-current-price"><BaseUtilsFormatCurrency :price="item.price_custom" /></div>
				</template>
			</div>
			<span v-if="item.extra_price_lowest && (item.discount_percent || item.discount_percent_custom) && item.extra_price_lowest != 0" class="cp-extra-price-lowest"><BaseCmsLabel code="extra_price_lowest" />: <strong><BaseUtilsFormatCurrency :price="item.extra_price_lowest" /></strong></span>

			<div class="cp-addtocart-instashop cp-addtocart-instashop-mobile">
				<WebshopAddToCartContainer :item="item" mode="instashop" />
				<CatalogSetWishlist :item="item" mode="instashop" />
			</div>
		</div>

		<div class="cp-addtocart-instashop">
			<WebshopAddToCartContainer :item="item" mode="instashop" />
			<CatalogSetWishlist :item="item" mode="instashop" />
		</div>
	</div>
</template>

<script setup>
	const props = defineProps(['item', 'mode']);
</script>

<style lang="less" scoped>
	.cp-instashop{
		width: 100%; border: 0; margin: 0; flex-flow: row; align-items: center; padding: 8px 24px 8px 0;
		&.hover{box-shadow: 0 0 10px 0 rgba(0,0,0,0.1);}
		@media (max-width: @t){padding: 4px 12px 4px 0;}
		@media (max-width: @tp){padding: 12px 16px; align-items: flex-start;}
	}
	.cp-image{
		:deep(img){max-width: 120px;}
		a{height: 120px; padding: 0; margin-bottom: 0;}
		@media (max-width: @t){
			:deep(img){max-width: 80px;}
			a{height: 80px;}
		}
		@media (max-width: @tp){
			min-height: unset;
			:deep(img){max-width: 120px; }
			a{height: 120px;}
		}
		@media (max-width: @m){
			
		}
	} 
	.cp-badges-container{
		left: 0; top: 0;
		@media (max-width: @tp){left: 16px; top: 12px;}
	}
	.cp-badge-discount{
		font-size: 18px; line-height: 22px; font-weight: normal;
		@media (max-width: @t){font-size: 16px; line-height: 18px;}
		@media (max-width: @tp){font-size: 18px; line-height: 22px;}
	}
	.cp-rates-cnt{
		padding: 0 16px;
		:deep(.cp-rate){
			justify-content: flex-start; padding: 0;
			span{
				width: 15px; height: 15px;
				&:after{width: 15px; height: 15px;}
			}
		}
		@media (max-width: @t){padding: 0 12px;}
		@media (max-width: @tp){
			:deep(.cp-rate){
				span{
					width: 13px; height: 13px;
					&:after{width: 13px; height: 13px;}
				}
			}
		}
	}
	.cp-brand{
		text-align: left; padding: 5px 16px 1px 16px; font-weight: bold;
		@media (max-width: @t){padding: 2px 16px 1px 12px;}
		@media (max-width: @tp){padding: 4px 12px 1px 12px; font-size: 14px; line-height: 22px;}
	}
	.cp-title{
		text-align: left; padding: 0 16px 4px 16px; flex-grow: unset;
		@media (max-width: @t){padding: 0 16px 2px 12px;}
		@media (max-width: @tp){padding: 0 12px 5px 12px; font-size: 16px; line-height: 19px;}
	}
	.cp-price{
		text-align: left; padding: 0 16px 2px 16px;
		@media (max-width: @t){padding: 0 16px 2px 12px;}
		@media (max-width: @tp){padding: 0 12px 1px 12px;}
	}
	.cp-current-price{
		@media (max-width: @tp){font-size: 16px; line-height: 20px;}
	}
	.cp-extra-price-lowest{
		text-align: left; padding: 0 16px;
		@media (max-width: @t){padding: 0 16px 0 12px;}
		@media (max-width: @tp){padding: 0 12px; font-size: 12px; line-height: 16px;}
	}
	.cp-addtocart-instashop{
		display: flex; gap: 8px; align-items: center;
		@media (max-width: @tp){display: none;}
	}
	.cp-addtocart-instashop-mobile{
		display: none; padding-top: 6px;
		@media (max-width: @tp){display: flex; padding-left: 12px;}
	}
</style>